import authAction from "./actions";

const expirationTime = localStorage.getItem("tokenExpiration");
const isTokenExpired = expirationTime && new Date().getTime() > expirationTime;

const initState = {
  isLogin: !isTokenExpired && localStorage.getItem("isLogin") === "true",
  accessToken: !isTokenExpired ? localStorage.getItem("accessToken") : null
};

if (isTokenExpired) {
  localStorage.removeItem("isLogin");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("tokenExpiration");
}

export default function rootReducer(state = initState, action) {
  switch (action.type) {
    case authAction.LOGIN:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: action.accessToken,
        email: action.email
      };
    case authAction.LOGOUT:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: null,
        email: null
      };
    default:
      return state;
  }
}
